package com.neurobs.ccabserver.transcriptreview.components.transcriptreview.components

import com.neurobs.ccabserver.transcriptreview.states.TestTranscriptSelection
import com.neurobs.react.StyleUtil
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.web.html.{b, className, div, style, table, tbody, td, tr}

@react
object TestTranscriptReviewInfoBar {
	case class Props(selection: TestTranscriptSelection, logfileFilename: String, userId: Long)

	val component = FunctionalComponent[Props] { props =>
		val sel = props.selection.transcript
		val thisReviewText = props.selection.reviewed.find(_.userId == props.userId) match {
			case None => "New"
			case Some(t) => s"Editing (${t.reviewedTestTranscriptId})"
		}
		val testRunText = props.logfileFilename + s" (${sel.testRunId})"
		val cellStyle = StyleUtil.makeStyle(("padding", "0.4em"))
		def makeRow(prop: String, value: String, prop2: String, value2: String) = tr(
			td(className := "right aligned", style := cellStyle, b(s"$prop:")),
			td(className := "left aligned", style := cellStyle, value),
			td(className := "right aligned", style := cellStyle, b(s"$prop2:")),
			td(className := "left aligned", style := cellStyle, value2)
		)

		div(style := StyleUtil.makeStyle(("width", "100%")))(
			table(className := "ui collapsing celled table", style := StyleUtil.makeStyle(("margin", "auto")))(
				tbody(
					makeRow(prop = "Test Run", testRunText, prop2 = "Study", sel.studyName),
					makeRow(prop = "Test", sel.testName, prop2 = "Test Transcript", sel.testTranscriptId.toString),
					makeRow(prop = "Account Subject", value = s"${sel.reportingId.noBracketsString} (${sel.accountSubjectId})", prop2 = "CASR Release", sel.casrReleaseId.toString),
					makeRow(prop = "Session", sel.subjectId.noBracketsString, prop2 = "This review", thisReviewText)
				)
			)
		)
	}
}
